var map = {
	"./breadcrumb/banner_bg.png": 4214,
	"./erp-home/background.png": 6438,
	"./erp-home/banner_shap.png": 7679,
	"./erp-home/shape.png": 8583,
	"./error_bg.png": 6964,
	"./home-chat/432-ai.png": 873,
	"./home-chat/arrow.png": 4000,
	"./home-chat/book.png": 2308,
	"./home-chat/box.png": 9976,
	"./home-chat/chat.png": 3193,
	"./home-chat/chat_icon.png": 6541,
	"./home-chat/cloud.png": 1224,
	"./home-chat/croppedchat.gif": 1483,
	"./home-chat/dashboard.png": 5879,
	"./home-chat/dot.png": 2894,
	"./home-chat/get_started_bg.png": 3075,
	"./home-chat/googleMeet.png": 83,
	"./home-chat/left_leaf.png": 1761,
	"./home-chat/live_chat.png": 7496,
	"./home-chat/mobile.png": 8581,
	"./home-chat/pluse.png": 3078,
	"./home-chat/right_leaf.png": 6090,
	"./home-chat/triangle.png": 1199,
	"./home-chat/video_icon.png": 860,
	"./home2/action_bg.png": 8734,
	"./home3/logo_01.png": 9858,
	"./home3/logo_02.png": 6921,
	"./home3/logo_03.png": 5744,
	"./home3/logo_04.png": 7071,
	"./home3/logo_05.png": 742,
	"./home4/action_shap.png": 5875,
	"./home4/banner_bg.png": 5592,
	"./home4/divider.png": 1139,
	"./home4/dot.png": 937,
	"./home4/review1.jpeg": 1262,
	"./home4/review2.jpeg": 2571,
	"./home4/review3.jpeg": 9828,
	"./home4/review4.jpeg": 7425,
	"./home4/review5.jpeg": 4474,
	"./home4/shape.png": 431,
	"./home5/banner_img.png": 5439,
	"./home5/featured_bg_shape.png": 4575,
	"./home5/icon1.png": 1589,
	"./home5/icon_shape.png": 6188,
	"./home5/shap_tecture.png": 9672,
	"./home7/banner.png": 7765,
	"./home8/dot.png": 7317,
	"./home9/flag.png": 7923,
	"./home9/footer.png": 9576,
	"./home9/icon_shape_two.png": 7075,
	"./home9/shape-footer.png": 1236,
	"./home9/shape.png": 7754,
	"./home9/shape_two.png": 9401,
	"./home9/triangle_bottom.png": 3399,
	"./home9/triangle_top.png": 397,
	"./mega-menu-img/icon/app-d.png": 9467,
	"./mega-menu-img/icon/blup.png": 8680,
	"./new-home/back_bg.png": 5986,
	"./new/digital_img.png": 9806,
	"./new/error.png": 1119,
	"./new/feedback_shap.png": 9811,
	"./new/leaf.png": 4857,
	"./new/new_shape.png": 1234,
	"./new/price_bg.png": 3902,
	"./new/shape_bg.png": 7362,
	"./new/solution_01.jpg": 6064,
	"./new/startup_banner_bg.png": 2359,
	"./new/startup_shap.png": 453,
	"./new/tab_shape_bg.png": 8698,
	"./new/testimonial_bg.png": 7748,
	"./new/testimonial_bg_shap.png": 4271,
	"./new/testimonial_bg_two.png": 4191,
	"./saas/map.png": 7583,
	"./seo/bike.png": 3521,
	"./seo/car.png": 6098,
	"./seo/cloud_bg.png": 1681,
	"./seo/footer_bg.png": 3905,
	"./seo/icons8-experiments-100.png": 6457,
	"./seo/icons8-homework-64.png": 5594,
	"./seo/icons8-lab-64.png": 4939,
	"./seo/icons8-laboratory-100.png": 7034,
	"./seo/icons8-live-streaming-100.png": 2620,
	"./seo/icons8-notebook-100.png": 1746,
	"./seo/icons8-notebook-58.png": 7012,
	"./seo/icons8-online-class-100.png": 2643,
	"./seo/icons8-online-class-58.png": 60,
	"./seo/icons8-project-100.png": 8014,
	"./seo/icons8-writing-100 (1).png": 6887,
	"./seo/icons8-writing-64.png": 4496,
	"./seo/lab2.png": 6379,
	"./seo/shap.png": 8144,
	"./seo/testin1.png": 1398,
	"./seo/testin2.png": 2637,
	"./seo/writing-100.png": 6590,
	"./svg.svg": 5018,
	"./tutorpoint_logo.png": 9142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;